import { AccountFactor } from './account-factor';

export class AccountFactorBatchChanges {
    inserts: AccountFactor[];
    updates: AccountFactor[];
    deletes: number[];
}
